import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportCategories = ({ 
  categories, 
  selectedCategory, 
  onCategorySelect, 
  reports, 
  selectedReport, 
  onReportSelect 
}) => {
  return (
    <div className="space-y-4">
      {/* Categories */}
      <div className="card">
        <div className="p-4 border-b border-border">
          <h3 className="text-lg font-heading-semibold text-text-primary">
            Categorías de Reportes
          </h3>
        </div>
        <div className="p-2">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => onCategorySelect(category)}
              className={`w-full flex items-start space-x-3 p-3 rounded-md text-left transition-micro ${
                selectedCategory === category.id
                  ? 'bg-primary-50 text-primary border border-primary-100' :'text-text-secondary hover:text-text-primary hover:bg-secondary-50'
              }`}
            >
              <Icon name={category.icon} size={20} className="mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="font-body-semibold text-sm">
                  {category.name}
                </div>
                <div className="text-xs text-text-muted mt-1">
                  {category.description}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Available Reports */}
      {selectedCategory && reports[selectedCategory] && (
        <div className="card">
          <div className="p-4 border-b border-border">
            <h3 className="text-lg font-heading-semibold text-text-primary">
              Reportes Disponibles
            </h3>
            <p className="text-sm text-text-secondary mt-1">
              {reports[selectedCategory].length} reporte{reports[selectedCategory].length !== 1 ? 's' : ''} disponible{reports[selectedCategory].length !== 1 ? 's' : ''}
            </p>
          </div>
          <div className="p-2">
            {reports[selectedCategory].map((report) => (
              <button
                key={report.id}
                onClick={() => onReportSelect(report)}
                className={`w-full flex items-center justify-between p-3 rounded-md text-left transition-micro ${
                  selectedReport?.id === report.id
                    ? 'bg-success-50 text-success border border-success-100' :'text-text-secondary hover:text-text-primary hover:bg-secondary-50'
                }`}
              >
                <div className="flex items-center space-x-3">
                  <Icon 
                    name={
                      report.type === 'chart' ? 'BarChart3' :
                      report.type === 'table' ? 'Table' :
                      report.type === 'metrics'? 'TrendingUp' : 'FileText'
                    } 
                    size={16} 
                  />
                  <span className="font-body-medium text-sm">
                    {report.name}
                  </span>
                </div>
                <div className={`px-2 py-1 rounded text-xs font-body-medium ${
                  report.type === 'chart' ? 'bg-primary-100 text-primary' :
                  report.type === 'table' ? 'bg-info-100 text-info' :
                  report.type === 'metrics'? 'bg-success-100 text-success' : 'bg-secondary-100 text-text-secondary'
                }`}>
                  {report.type === 'chart' ? 'Gráfico' :
                   report.type === 'table' ? 'Tabla' :
                   report.type === 'metrics'? 'Métricas' : 'Dashboard'}
                </div>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Quick Actions */}
      <div className="card">
        <div className="p-4 border-b border-border">
          <h3 className="text-lg font-heading-semibold text-text-primary">
            Acciones Rápidas
          </h3>
        </div>
        <div className="p-4 space-y-3">
          <button className="w-full flex items-center space-x-3 p-3 text-sm font-body-medium text-text-secondary hover:text-text-primary hover:bg-secondary-50 rounded-md transition-micro">
            <Icon name="Bookmark" size={16} />
            <span>Reportes Favoritos</span>
          </button>
          <button className="w-full flex items-center space-x-3 p-3 text-sm font-body-medium text-text-secondary hover:text-text-primary hover:bg-secondary-50 rounded-md transition-micro">
            <Icon name="Clock" size={16} />
            <span>Reportes Programados</span>
          </button>
          <button className="w-full flex items-center space-x-3 p-3 text-sm font-body-medium text-text-secondary hover:text-text-primary hover:bg-secondary-50 rounded-md transition-micro">
            <Icon name="Share" size={16} />
            <span>Reportes Compartidos</span>
          </button>
          <button className="w-full flex items-center space-x-3 p-3 text-sm font-body-medium text-text-secondary hover:text-text-primary hover:bg-secondary-50 rounded-md transition-micro">
            <Icon name="History" size={16} />
            <span>Historial</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportCategories;